const tableColumns = [
    {
        Header: "S.no",
        id: "s_no",
        width: "70"
    },
    {
        Header: "Name",
        accessor: "enrolment.name",
    },
    {
        Header: "FIN",
        accessor: "enrolment.fin",
    },
    {
        Header: "Sponsor Company",
        accessor: "enrolment.sponsor_company.name",
        width: "250"
    },
    {
        Header: "Type of trade",
        accessor: "enrolment.type_of_trade",
    },
    {
        Header: "Result",
        accessor: "enrolment.result",
    },
    {
        Header: "Result date",
        accessor: "enrolment.result_date",
    },
];

export { tableColumns };
